import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const ComposeIcon = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path
        fillRule="evenodd"
        d="m22.2 6.2-9.5 9.5a1 1 0 0 1-.5.3l-4 1A1 1 0 0 1 7 15.8l1-4c0-.2.2-.4.3-.5l9.5-9.5a3.1 3.1 0 0 1 4.4 4.4Zm-3-3a1.1 1.1 0 0 1 1.6 1.6l-.8.8L18.4 4l.8-.8ZM17 5.4 18.6 7l-7.1 7.1-.8.2-1-1 .2-.8 7.1-7Z"
        clipRule="evenodd"
      />
      <path d="M4 3a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-7a1 1 0 1 0-2 0v7a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h7a1 1 0 1 0 0-2H4Z" />
    </Icon>
  )
);
export default ComposeIcon;
